// 提交问题

import QuestionService from '@/service/question';

const submitQuestion = async (question: string, answer: any, year: any) => {
  const result = await QuestionService.submitAnswer({
    question,
    answer,
    year,
  });
  return result;
};


export {
  submitQuestion,
};
